import React, { useState } from 'react';
import { IonButton, IonContent, IonPage } from '@ionic/react';
import { App as CapacitorApp } from '@capacitor/app';

import SplashScreen from '../components/SplashScreen';

import './AgeGateUnavailable.css';

interface AgeGateUnavailableProps {
  appName: string;
  message: string;
  platform: string;
}

function AgeGateUnavailable({
  appName,
  message,
  platform,
}: AgeGateUnavailableProps) {
  const [closeMessage, setCloseMessage] = useState('');

  const handleCloseApp = async () => {
    setCloseMessage('');

    if (platform !== 'android') {
      setCloseMessage(`Close ${appName} from the app switcher to leave the app.`);
      return;
    }

    try {
      await CapacitorApp.exitApp();
    } catch (error) {
      console.error(error);
      setCloseMessage(`Unable to close ${appName} on this device.`);
    }
  };

  return (
    <IonPage>
      <IonContent fullscreen={true} className="age-gate-unavailable-content">
        <div className="age-gate-unavailable-background">
          <div className="age-gate-unavailable-words">
            <div className="age-gate-unavailable-overlay">
              <div className="age-gate-unavailable-shell">
                <div className="age-gate-unavailable-logo">
                  <SplashScreen play={false} callback={() => {/** Intentionally empty */}} />
                </div>

                <div className="age-gate-unavailable-body">
                  <div className="age-gate-unavailable-panel">
                    <p className="age-gate-unavailable-message">{message}</p>

                    {closeMessage ? (
                      <p className="age-gate-unavailable-note">{closeMessage}</p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}

export default AgeGateUnavailable;
